import { dataTeamSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTeamSolid = /*#__PURE__*/createIcon(dataTeamSolid)
export default IconTeamSolid
